import React from 'react';
export function PrivacyContent() {
  return <div className="prose prose-stone max-w-none" data-id="element-151">
      <p className="text-stone-600 mb-6" data-id="element-152">
        Última actualización:{' '}
        {new Date().toLocaleDateString('es-ES', {
        year: 'numeric',
        month: 'long',
        day: 'numeric'
      })}
      </p>

      <section className="mb-8" data-id="element-153">
        <h3 className="text-xl font-bold text-stone-900 mb-3" data-id="element-154">
          1. Información que Recopilamos
        </h3>
        <p className="text-stone-700 leading-relaxed mb-4" data-id="element-155">
          Cuando adquieres "Puentes de Palabras", recopilamos únicamente la
          información necesaria para procesar tu compra y entregarte el producto
          digital:
        </p>
        <ul className="list-disc pl-6 space-y-2 text-stone-700" data-id="element-156">
          <li data-id="element-157">Nombre y dirección de correo electrónico</li>
          <li data-id="element-158">
            Información de pago (procesada de forma segura por nuestro proveedor
            de pagos)
          </li>
          <li data-id="element-159">Datos de uso del sitio web (cookies y análisis)</li>
        </ul>
      </section>

      <section className="mb-8" data-id="element-160">
        <h3 className="text-xl font-bold text-stone-900 mb-3" data-id="element-161">
          2. Uso de tu Información
        </h3>
        <p className="text-stone-700 leading-relaxed mb-4" data-id="element-162">
          Utilizamos tu información para:
        </p>
        <ul className="list-disc pl-6 space-y-2 text-stone-700" data-id="element-163">
          <li data-id="element-164">Procesar y entregar tu compra del ebook</li>
          <li data-id="element-165">Enviarte el producto digital y materiales relacionados</li>
          <li data-id="element-166">Comunicarnos contigo sobre tu compra</li>
          <li data-id="element-167">Mejorar nuestros productos y servicios</li>
          <li data-id="element-168">Cumplir con obligaciones legales</li>
        </ul>
      </section>

      <section className="mb-8" data-id="element-169">
        <h3 className="text-xl font-bold text-stone-900 mb-3" data-id="element-170">
          3. Protección de Datos
        </h3>
        <p className="text-stone-700 leading-relaxed" data-id="element-171">
          Implementamos medidas de seguridad técnicas y organizativas para
          proteger tu información personal contra acceso no autorizado,
          alteración, divulgación o destrucción. Todos los pagos se procesan a
          través de plataformas seguras y encriptadas.
        </p>
      </section>

      <section className="mb-8" data-id="element-172">
        <h3 className="text-xl font-bold text-stone-900 mb-3" data-id="element-173">
          4. Compartir Información
        </h3>
        <p className="text-stone-700 leading-relaxed" data-id="element-174">
          No vendemos, alquilamos ni compartimos tu información personal con
          terceros, excepto cuando sea necesario para procesar tu compra
          (procesadores de pago) o cuando lo requiera la ley.
        </p>
      </section>

      <section className="mb-8" data-id="element-175">
        <h3 className="text-xl font-bold text-stone-900 mb-3" data-id="element-176">
          5. Tus Derechos
        </h3>
        <p className="text-stone-700 leading-relaxed mb-4" data-id="element-177">Tienes derecho a:</p>
        <ul className="list-disc pl-6 space-y-2 text-stone-700" data-id="element-178">
          <li data-id="element-179">Acceder a tu información personal</li>
          <li data-id="element-180">Solicitar la corrección de datos inexactos</li>
          <li data-id="element-181">Solicitar la eliminación de tu información</li>
          <li data-id="element-182">Oponerte al procesamiento de tus datos</li>
          <li data-id="element-183">Retirar tu consentimiento en cualquier momento</li>
        </ul>
      </section>

      <section className="mb-8" data-id="element-184">
        <h3 className="text-xl font-bold text-stone-900 mb-3" data-id="element-185">6. Cookies</h3>
        <p className="text-stone-700 leading-relaxed" data-id="element-186">
          Utilizamos cookies para mejorar tu experiencia en nuestro sitio web,
          analizar el tráfico y personalizar el contenido. Puedes configurar tu
          navegador para rechazar cookies, aunque esto puede afectar algunas
          funcionalidades del sitio.
        </p>
      </section>

      <section className="mb-8" data-id="element-187">
        <h3 className="text-xl font-bold text-stone-900 mb-3" data-id="element-188">
          7. Cambios a esta Política
        </h3>
        <p className="text-stone-700 leading-relaxed" data-id="element-189">
          Podemos actualizar esta política de privacidad ocasionalmente. Te
          notificaremos sobre cambios significativos publicando la nueva
          política en esta página con una fecha de actualización revisada.
        </p>
      </section>

      <section data-id="element-190">
        <h3 className="text-xl font-bold text-stone-900 mb-3" data-id="element-191">8. Contacto</h3>
        <p className="text-stone-700 leading-relaxed" data-id="element-192">
          Si tienes preguntas sobre esta política de privacidad o sobre cómo
          manejamos tu información, por favor contáctanos a través del correo
          electrónico proporcionado en el momento de la compra.
        </p>
      </section>
    </div>;
}